import { Stack, Typography, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'

import ActionsList from '~/layouts/account/scenariosLayout/scenariosSideNav/actionsList'
import ScenariosList from '~/layouts/account/scenariosLayout/scenariosSideNav/scenariosList'
import { EClientPath } from '~/models/api'
import rem from '~/utils/ui'

type TProps = {
  onClose: () => void
}

function DrawerContent({ onClose }: TProps) {
  const theme = useTheme()

  return (
    <Stack height="100%">
      <Typography
        component={Link}
        to={EClientPath.manageScenarios}
        variant="h6"
        sx={{
          fontSize: rem(16),
          lineHeight: rem(20),
          fontWeight: 700,
          letterSpacing: rem(1),
          mb: rem(5),
          textDecoration: 'none',
          color: theme.palette.mainFont,
        }}
      >
        Overview
      </Typography>
      <ScenariosList close={onClose} sx={{ mb: rem(24) }} />
      <ActionsList close={onClose} sx={{ mb: rem(24) }} />
    </Stack>
  )
}

export default DrawerContent
